import { render } from "./messagNotice.vue?vue&type=template&id=4d8ce592"
import script from "./messagNotice.vue?vue&type=script&lang=js"
export * from "./messagNotice.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__